var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStep02(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 119,
    height: 111,
    viewBox: "0 0 119 111",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cls-1,.cls-4,.cls-5,.cls-7{fill:none}.cls-1{stroke:#707070;stroke-width:2px}.cls-2,.cls-8{fill:#4b4b4b}.cls-3{fill:#fff}.cls-4{stroke:#4b4b4b;stroke-linecap:round;stroke-miterlimit:10}.cls-6,.cls-8{stroke:none}\n        "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Unit_icon",
    transform: "translate(-1769 -936)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_527"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Unit",
    transform: "translate(875 441)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_187",
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H36V33H0z",
    className: "cls-6",
    transform: "translate(935 517)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 1H35V32H1z",
    className: "cls-7",
    transform: "translate(935 517)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_347",
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H37V33H0z",
    className: "cls-6",
    transform: "translate(894 517)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 1H36V32H1z",
    className: "cls-7",
    transform: "translate(894 517)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_190",
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H119V18H0z",
    className: "cls-6",
    transform: "translate(894 495)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 1H118V17H1z",
    className: "cls-7",
    transform: "translate(894 495)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_348",
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H119V9H0z",
    className: "cls-6",
    transform: "translate(894 597)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 1H118V8H1z",
    className: "cls-7",
    transform: "translate(894 597)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_189",
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H36V37H0z",
    className: "cls-6",
    transform: "translate(935 555)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 1H35V36H1z",
    className: "cls-7",
    transform: "translate(935 555)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_346",
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H37V37H0z",
    className: "cls-6",
    transform: "translate(894 555)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 1H36V36H1z",
    className: "cls-7",
    transform: "translate(894 555)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_188",
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H38V75H0z",
    className: "cls-6",
    transform: "translate(975 517)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 1H37V74H1z",
    className: "cls-7",
    transform: "translate(975 517)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "icon_mixer",
    transform: "translate(899.13 563.662)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_341",
    d: "M35.708 24.132a.834.834 0 0 0-.9-.9h-.757v-.689a.854.854 0 0 0-.97-.97h-6.1v-.844h1.94a.834.834 0 0 0 .912-.893V19.1a2.309 2.309 0 0 0 .34-.116.815.815 0 0 0 .485-.805v-2.458h.834a.805.805 0 0 0 .825-.776 7.616 7.616 0 0 0 0-.97.815.815 0 0 0-.805-.776 3.629 3.629 0 0 0-.563 0c-.272 0-.388-.058-.475-.33A4.152 4.152 0 0 0 26.589 9.9H13.172a4.162 4.162 0 0 0-2.231 7.674 4.007 4.007 0 0 0 2.144.65.815.815 0 0 1 .873 1.038q-1.193 6.549-2.406 13.1a.97.97 0 0 1-.97.893A1.63 1.63 0 0 0 9 35a1.669 1.669 0 0 0 1.678 1.572H32.7a1.232 1.232 0 0 0 1.31-1.242 1.251 1.251 0 0 0-1.3-1.261h-2.852V32.7a.33.33 0 0 1 .2-.33 7.451 7.451 0 0 0 3.095-3.124.417.417 0 0 1 .281-.175h1.339a.815.815 0 0 0 .912-.912q.043-2.019.023-4.027zm-4.977-10.051h.805v.766h-.805zM29.024 19.9h-4.967v-.786h4.967zm-9.954 6.26a7.354 7.354 0 0 0 3.813 6.151c.262.155.378.3.33.592v.456a2.348 2.348 0 0 1-.3-.126 8.208 8.208 0 0 1-4.7-7.393c-.049-1.688 0-3.376 0-5.064a1.64 1.64 0 0 1 1.688-1.7h3.308v.776a.825.825 0 0 0 .873.854h2.028v.844h-6.128a.825.825 0 0 0-.97.863c.029 1.263-.02 2.515.058 3.747zm10.8-10.419v.805s-3.134.068-6.325 0a46.567 46.567 0 0 1-6.442-.31 35.343 35.343 0 0 1 6.452-.534c3.192-.1 6.3-.078 6.345-.078v.116zm2.83 19.17c.213 0 .407 0 .485.252a.417.417 0 0 1-.427.572H10.872a1.378 1.378 0 0 1-.446-.058.805.805 0 0 1-.543-.893.834.834 0 0 1 .776-.718A1.727 1.727 0 0 0 12.4 32.5q.97-5.287 1.94-10.555c.165-.873.291-1.766.495-2.629a1.62 1.62 0 0 0-1.465-1.94 3.628 3.628 0 0 1-2.231-.737 3.347 3.347 0 0 1-1.106-3.609 3.25 3.25 0 0 1 2.978-2.309H26.4a3.289 3.289 0 0 1 3.352 2.679h.068v1.446s-3.415 0-6.791.087c-1.94.078-3.551.184-4.7.32-1.766.213-2.435.485-2.474.97a.456.456 0 0 0 .136.359c.194.213.572.6 7.305.66H25c2.5 0 4.628 0 4.851-.049v.97h-9.782a2.532 2.532 0 0 0-2.7 2.687v4.705a9.158 9.158 0 0 0 7.334 9.09 10.448 10.448 0 0 0 1.94.194c2.051.081 4.05.072 6.057.072zm-8.663-2.076a7.926 7.926 0 0 0 5 0v1.193a18.258 18.258 0 0 1-4.511-.213c-.466-.116-.466-.116-.466-.582zm8.13-3.522a6.655 6.655 0 0 1-12.185-2.474c-.136-.893-.107-1.814-.155-2.746v-1.678h13.427v2.066a7.81 7.81 0 0 1-1.087 4.831zm2.687-1.087h-1.261a10.672 10.672 0 0 0 .456-4.143h.805z",
    className: "cls-2",
    transform: "translate(-8.996 -9.9)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "icon_drill",
    transform: "translate(938.219 565.922)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_352",
    d: "M21.463 37.654a1.608 1.608 0 0 1-1.608-1.608v-3.208l3.95-2.545h1.609v-5.446a.835.835 0 0 0-.835-.835h-1.6v-2.433H17.89V13.74h13.8a3.991 3.991 0 0 1 4.021 3.828A3.93 3.93 0 0 1 31.8 21.64h-.95v8.949l1.334 1.832v3.665a1.6 1.6 0 0 1-1.609 1.609zm-.835-4.388v2.779a.835.835 0 0 0 .835.835h9.091a.814.814 0 0 0 .825-.733v-2.973h-5.416l-1.944-2.128-3.37 2.219zM26.3 32.4h4.937l-1.161-1.608v-10h1.659a3.2 3.2 0 0 0 3.217-3.054 3.146 3.146 0 0 0-3.145-3.238H18.633v.926h2.036v.764h-2.036v1.018h2.036v.865h-2.036v1.018h2.036v.764h-2.036v.926h7.513v.774h-1.17v1.7h.071a1.609 1.609 0 0 1 1.1 1.578v6.19h-1.1L26.3 32.39zm-2.545-9.162h.438v-1.659h-.438v1.649z",
    className: "cls-2",
    transform: "translate(-6.162 -13.74)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_353",
    d: "M14.138 20.553A2.8 2.8 0 0 1 11.6 18.11v-.051H6.757a.387.387 0 0 1-.387-.387.387.387 0 0 1 .387-.387H11.5v-.092a2.789 2.789 0 0 1 2.565-2.443h2.922a.4.4 0 0 1 .387.4v5.09a.387.387 0 0 1-.387.387zm0-5.09a2.036 2.036 0 0 0-1.792 2.037v.265a2.036 2.036 0 0 0 1.792 2.035h.112v-4.327zm1.273 4.316h.764a.387.387 0 0 0 .387-.387v-3.563a.387.387 0 0 0-.387-.387h-.886a.387.387 0 0 0-.387.387v3.563a.387.387 0 0 0 .428.407z",
    className: "cls-2",
    transform: "translate(-6.37 -13.722)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_146",
    d: "M0 0H2.24V0.774H0z",
    className: "cls-2",
    transform: "translate(23.883 1.446)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_147",
    d: "M0 0H2.24V0.774H0z",
    className: "cls-2",
    transform: "translate(23.883 2.912)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_835",
    d: "M0 0H18V8H0z",
    className: "cls-3",
    transform: "translate(904 543)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "icon_Printer",
    transform: "translate(896.678 526.299)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_334",
    d: "M31.587 19.92a.837.837 0 1 0 .837.837.837.837 0 0 0-.837-.837z",
    className: "cls-3",
    transform: "translate(-6.215 -9.3)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_335",
    d: "M33.937 19.92a.837.837 0 1 0 .837.837.837.837 0 0 0-.837-.837z",
    className: "cls-3",
    transform: "translate(-6.137 -9.3)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_126",
    width: 14.494,
    height: 0.744,
    className: "cls-3",
    rx: 0.34,
    transform: "translate(10.031 21.395)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_127",
    width: 14.494,
    height: 0.744,
    className: "cls-3",
    rx: 0.34,
    transform: "translate(10.031 23.606)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_128",
    width: 14.494,
    height: 0.744,
    className: "cls-3",
    rx: 0.34,
    transform: "translate(10.031 19.195)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_129",
    width: 1.684,
    height: 1.684,
    className: "cls-2",
    rx: 0.81,
    transform: "translate(23.575 9.773)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_130",
    width: 1.684,
    height: 1.684,
    className: "cls-2",
    rx: 0.81,
    transform: "translate(26.002 9.773)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_131",
    width: 14.494,
    height: 0.744,
    className: "cls-2",
    rx: 0.34,
    transform: "translate(9.081 20.558)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_132",
    width: 14.494,
    height: 0.744,
    className: "cls-2",
    rx: 0.34,
    transform: "translate(9.081 22.769)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_133",
    width: 14.494,
    height: 0.744,
    className: "cls-2",
    rx: 0.34,
    transform: "translate(9.081 18.347)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_337",
    d: "M37.124 16.77H9.521A2.5 2.5 0 0 0 7 19.3v9.95a2.51 2.51 0 0 0 2.479 2.541h4.8v-.93H9.521a1.57 1.57 0 0 1-1.488-1.611V19.3a1.55 1.55 0 0 1 1.539-1.59h27.552a1.56 1.56 0 0 1 1.55 1.591v9.949a1.57 1.57 0 0 1-1.55 1.612h-4.886v.93h4.886A2.51 2.51 0 0 0 39.6 29.25V19.3a2.5 2.5 0 0 0-2.479-2.531z",
    className: "cls-2",
    transform: "translate(-7 -9.404)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_338",
    d: "M32.523 34.73H13.68v-9.36h18.843zm-17.913-.94h16.963v-7.48H14.61z",
    className: "cls-2",
    transform: "translate(-6.779 -9.12)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_339",
    d: "M32.291 17.006h-.93V10.57H14.75v6.436h-.93V9.64h18.471z",
    className: "cls-2",
    transform: "translate(-6.775 -9.64)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "icon_dyson",
    transform: "rotate(-16 2384.995 -3175.115)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2271",
    d: "M.363 0l2.775.757-1.151 2.586L.079 4.557 0 2.3z",
    className: "cls-3",
    transform: "translate(28.81 16.32)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2272",
    d: "M2.98 0l12.143 5.251 1.088.568-.127 1.581a1.262 1.262 0 0 1-.915 1.12l-3.643 1.1L0 3.863V2.681S.489.016 2.98 0z",
    className: "cls-4",
    transform: "translate(.016 50.917)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_45",
    cx: 1.908,
    cy: 1.908,
    r: 1.908,
    className: "cls-4",
    transform: "translate(11.511 56.026)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2273",
    d: "M0 0l11.48 5.63v1.293",
    className: "cls-4",
    transform: "translate(0 53.629)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2274",
    d: "M0 8.373l3.564-.363.6-.694L6.97.725 7.963 0l1.75.867.032 1.088-2.192 5.188-.615.8-.331 2.113-.741.978",
    className: "cls-4",
    transform: "translate(8.058 44.641)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2275",
    d: "M1.829 27.186L13.688 1.041S13.94.095 12.111 0L0 26.319",
    className: "cls-4",
    transform: "translate(16.021 18.322)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2276",
    d: "M1.009 0L0 2.665l.237.8",
    className: "cls-4",
    transform: "translate(27.785 15.027)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2277",
    d: "M1.577 0L.836 2.586 0 3.122",
    className: "cls-4",
    transform: "translate(29.63 16.241)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2278",
    d: "M1.036 2.46C.232 1.8-.178 1.025.074.488s1.908-.757 3.438 0 2.46 1.955 2.1 2.712-.867.725-1.908.489",
    className: "cls-4",
    transform: "translate(27.096 13.971)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2279",
    d: "M0 8.29L3.832.406S7.3-1.439 9.335 2.74l-3.753 8.389",
    className: "cls-4",
    transform: "translate(27.202 5.995)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2280",
    d: "M.073 2.491S-.542 2.349 1.792.346c0 0 2.807-1.577 4.636 2a16.579 16.579 0 0 1 0 2.066.536.536 0 0 1-.615.52",
    className: "cls-4",
    transform: "translate(30.661 3.737)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2281",
    d: "M0 3.7L1.577.251A2.838 2.838 0 0 1 5.456 2L4.132 5.691",
    className: "cls-4",
    transform: "translate(32.957)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2282",
    d: "M.694 0l1.75 1.8s.142.962-1.293 1.325L0 2.255",
    className: "cls-4",
    transform: "translate(36.474 6.795)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2283",
    d: "M3.453.144L5.819 0a.489.489 0 0 1 .489.7L4.179 5.648v.8L3.359 7l-1.577.11-.394-.41H.9l-.222-.784L0 6.121",
    className: "cls-4",
    transform: "translate(34.503 7.329)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_67",
    d: "M0 0L2.381 1.845",
    className: "cls-4",
    transform: "translate(35.197 11.526)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "icon_projector",
    transform: "translate(939.219 528.486)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_346",
    d: "M10.5 31.545a1.691 1.691 0 0 1-1.69-1.691V17.072a1.672 1.672 0 0 1 1.672-1.672h12.409l-.669.816a5.9 5.9 0 0 0 3.8 9.607 6.676 6.676 0 0 0 .767 0 5.8 5.8 0 0 0 3.933-1.475 5.9 5.9 0 0 0 1.967-4.425 5.831 5.831 0 0 0-1.347-3.756l-.708-.757H34.9a1.662 1.662 0 0 1 1.662 1.652v12.782a1.691 1.691 0 0 1-1.691 1.691zm0-15.133a.659.659 0 0 0-.669.669v12.783a.688.688 0 0 0 .688.688H34.9a.688.688 0 0 0 .688-.688V17.081a.659.659 0 0 0-.659-.649h-2.245l.069.118a6.7 6.7 0 0 1 .924 3.45 6.883 6.883 0 0 1-6.883 6.883 8.317 8.317 0 0 1-.855 0A6.992 6.992 0 0 1 20.8 16.531l.069-.118z",
    className: "cls-2",
    transform: "translate(-8.81 -13.068)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_139",
    d: "M0 0H5.664V1.003H0z",
    className: "cls-2",
    transform: "translate(3.491 6.413)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_140",
    d: "M0 0H5.664V1.003H0z",
    className: "cls-2",
    transform: "translate(3.491 9.323)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_141",
    d: "M0 0H5.664V1.003H0z",
    className: "cls-2",
    transform: "translate(3.491 12.234)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_142",
    d: "M0 0H4.494V1.583H0z",
    className: "cls-2",
    transform: "translate(19.203 18.055)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_143",
    d: "M0 0H4.494V1.583H0z",
    className: "cls-2",
    transform: "translate(4.071 18.055)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Path_2461",
    className: "cls-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.817 0A6.817 6.817 0 1 1 0 6.817 6.817 6.817 0 0 1 6.817 0z",
    className: "cls-6",
    transform: "translate(11.094 .099)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.817 1C3.61 1 1 3.61 1 6.817c0 3.208 2.61 5.818 5.817 5.818 3.208 0 5.818-2.61 5.818-5.818C12.635 3.61 10.025 1 6.817 1m0-1c3.766 0 6.818 3.052 6.818 6.817 0 3.766-3.052 6.818-6.818 6.818C3.052 13.635 0 10.583 0 6.817 0 3.052 3.052 0 6.817 0z",
    className: "cls-8",
    transform: "translate(11.094 .099)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path_2460",
    className: "cls-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.9 0A3.9 3.9 0 1 1 0 3.9 3.9 3.9 0 0 1 3.9 0z",
    className: "cls-6",
    transform: "translate(14.015 3.021)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.896 1C2.299 1 1 2.299 1 3.896 1 5.492 2.299 6.79 3.896 6.79c1.596 0 2.895-1.299 2.895-2.895C6.791 2.299 5.492 1 3.896 1m0-1C6.047 0 7.79 1.744 7.79 3.896c0 2.151-1.744 3.895-3.895 3.895C1.744 7.791 0 6.047 0 3.896 0 1.744 1.744 0 3.896 0z",
    className: "cls-8",
    transform: "translate(14.015 3.021)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path_2459",
    className: "cls-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.461 0A1.461 1.461 0 1 1 0 1.461 1.461 1.461 0 0 1 1.461 0z",
    className: "cls-6",
    transform: "translate(16.45 5.456)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.46 1c-.253 0-.46.207-.46.46 0 .255.207.462.46.462.255 0 .462-.207.462-.461S1.715 1 1.46 1m0-1c.807 0 1.46.654 1.46 1.46 0 .808-.653 1.462-1.46 1.462C.654 2.922 0 2.268 0 1.46S.654 0 1.46 0z",
    className: "cls-8",
    transform: "translate(16.45 5.456)"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStep02);
export default __webpack_public_path__ + "static/media/step0_2.754c2ac339bd2319f6dbb11c84a30f4e.svg";
export { ForwardRef as ReactComponent };